import _ from 'lodash';

import EventService from '../services/EventService';

const buildEvent = (state, eventType, eventData = null) => {
  const {
    ui: { selectedPlan },
    okta: { user },
  } = state;
  const timeStamp = new Date().toISOString();
  const planGuid = selectedPlan?.planId || null;
  return {
    userName: user?.name,
    timeStamp,
    eventType,
    planGuid,
    eventData,
  };
};

export const addEvent = (eventType, eventData = null) => {
  return (dispatch, getState) => {
    const datas = _.isArray(eventData) ? eventData : [eventData];
    const requests = _.map(datas, (d) =>
      buildEvent(getState(), eventType, d)
    );
    return EventService().addEvent(requests);
  };
};

export const lastEvent = (getState, eventType) => {
  const {
    okta: { accessToken },
  } = getState();
  const query = buildEvent(getState(), eventType);
  return EventService().lastEvent(accessToken, query);
};
